import { bodyFont, neutralFillRest, neutralForegroundRest, typeRampBaseLineHeight, typeRampMinus1FontSize } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
import { display } from "@microsoft/fast-foundation";
export const titleBarStyles = (context, definition) => css `
    ${display("inline-flex")} :host {
        box-sizing: border-box;
        font-family: ${bodyFont};
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        padding: 12px 16px;
        width: 100%;
        height: 48px;
        font-size: ${typeRampMinus1FontSize};
        font-weight: 400;
        line-height: ${typeRampBaseLineHeight};
        --openHandCursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='Layer_2' data-name='Layer 2' width='32' height='32' viewBox='0 0 32 32'%3E%3Cpath d='M15.985,4.365c-.822,0-1.371.585-1.489,1.559V3.444c0-1.188-.6-1.956-1.536-1.956-.822,0-1.354.563-1.472,1.529V2.3c0-1.08-.565-1.7-1.55-1.7-.965,0-1.455.572-1.455,1.7V3.8A1.429,1.429,0,0,0,6.992,2.456c-.555,0-1.486.236-1.486,1.813L5.469,14.387a9.6,9.6,0,0,0-2.822-1.882,1.486,1.486,0,0,0-.7-.088A1.6,1.6,0,0,0,.536,14.176a1.544,1.544,0,0,0,.591,1.056v0a71.374,71.374,0,0,1,4.388,5.738l.07.083C6.943,22.343,8.353,23.5,10.653,23.5A6.877,6.877,0,0,0,17.5,16.3V6.32C17.5,5.114,16.919,4.365,15.985,4.365Z' style='fill:%23fff'/%3E%3Cpath d='M9.938,1.1c.754,0,1.05.442,1.05,1.2v8.1c0,.3.256.833.553.833s.422-.537.422-.833V3.444c0-.757.239-1.456,1-1.456S14,2.687,14,3.444v7.489a.537.537,0,0,0,.535.536c.294,0,.438-.493.441-.785V6.312c0-.754.258-1.447,1.013-1.447S17,5.562,17,6.32V16.3A6.348,6.348,0,0,1,10.654,23c-2.075,0-3.329-.985-4.724-2.308a71.652,71.652,0,0,0-4.423-5.785c-.009-.009-.01-.019-.022-.029a1.077,1.077,0,0,1-.452-.758,1.1,1.1,0,0,1,.972-1.207.977.977,0,0,1,.108-.006,1.064,1.064,0,0,1,.364.068c.769.157,2.5,1.682,3.488,2.449L6.006,4.271c0-.761.23-1.315.985-1.315s1.026.554,1.026,1.315l-.011,6.373s.022.6.509.6a.513.513,0,0,0,.469-.567V2.3c0-.758.2-1.2.954-1.2m0-1A1.87,1.87,0,0,0,7.985,2.194a2.111,2.111,0,0,0-.994-.238c-.465,0-1.985.167-1.985,2.315l-.033,9.082a6.931,6.931,0,0,0-2.221-1.341,2.065,2.065,0,0,0-.639-.105,1.894,1.894,0,0,0-.224.013A2.083,2.083,0,0,0,.782,15.6c2.254,2.614,4.3,5.625,4.321,5.655l.06.09.079.074C6.676,22.778,8.169,24,10.654,24A7.366,7.366,0,0,0,18,16.3V6.32c0-1.812-1.086-2.455-2.015-2.455A1.947,1.947,0,0,0,15,4.13V3.444C15,1.975,14.178.988,12.96.988a1.9,1.9,0,0,0-1.124.359A1.912,1.912,0,0,0,9.938.1Z' style='fill:%23121527'/%3E%3C/svg%3E")
                8 8,
            grab;
    }

    a {
        outline: none;
        color: ${neutralForegroundRest};
        text-decoration: none;
    }

    a:hover,
    a:focus-visible {
        text-decoration: underline;
    }

    img {
        margin-inline-end: 8px;
        width: 16px;
    }

    fluent-widget-action-menu {
        margin-inline-start: auto;
    }

    .cardActionsSection {
        display: inline-flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        margin-inline-start: auto;
        z-index: 1;
    }

    .titlebar-text {
        z-index:1;
        width: -webkit-fill-available;
    }

    .titlebar-title,
    .titlebar-icon {
        vertical-align: middle;
    }

    fluent-button {
        margin-inline-start: 14px;
        border-radius: 3px;
        height: 24px;
        width: 24px;
        min-width: 24px;
        background: transparent;
    }

    fluent-button:hover {
        border-radius: 3px;
        background: ${neutralFillRest};
    }

    fast-progress-ring {
        margin-inline-end: 8px;
        height: 16px;
        width: 16px;
        display: inline-block;
    }

    .errorSection {
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        padding: 0px 10px 0px 0px;
    }
`;
